import { createContext } from "react";
const LocaleContext = createContext({
  countryCode: 'CL',
  setCountryCode: (_) => {},
  showSwitch: true,
  setShowSwitch: (_) => {}
});
export default LocaleContext;